module.exports = __webpack_public_path__ + "static/img/top5-xxjj.d505165.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top5-xxjj.png
// module id = c4Av
// module chunks = 12